// extracted by mini-css-extract-plugin
export default {"aboutBG":"IyioonBG_aboutBG__0AmiZ","aboutBGContent":"IyioonBG_aboutBGContent__7w4yG","aboutBGContentDark":"IyioonBG_aboutBGContentDark__rdugJ"};